export default {"src":"/_next/static/media/warning-icon.57656601.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};